module.exports = __webpack_public_path__ + "img/图4.e3476e78.png";